<template>
	<div class="container">
		<div class="page-header">
			<h2 class="h2">Editar Lead</h2>
			<router-link to="/dashboard" class="btn btn-secondary">Voltar</router-link>
		</div>

		<div class="card">
			<div class="candidate-form">
				<div class="form-row">
					<div class="form-group">
						<label for="nome">Nome Completo *</label>
						<input type="text" id="nome" v-model="formData.nome" required placeholder="Nome completo" />
					</div>

					<div class="form-group">
						<label for="idade">Idade *</label>
						<input type="number" id="idade" v-model="formData.idade" required placeholder="Idade" />
					</div>

					<div class="form-group">
						<label for="telefone">Telefone *</label>
						<input type="tel" id="telefone" v-model="formData.telefone" required
							placeholder="(11) 99999-9999" @input="formatPhone" />
					</div>

					<div class="form-group">
						<label for="responsavel">Responsável (se menor de idade)</label>
						<input type="text" id="responsavel" v-model="formData.responsavel"
							placeholder="Nome do responsável" />
					</div>

					<div class="form-group">
						<label for="responsavel">Observação</label>
						<textarea id="observacao" name="observacao" rows="5" cols="33" placeholder="Observação"
							class="textarea-observacao" v-model="formData.observacao" maxlength="500"></textarea>
						<span class="caracteres-restantes">{{ 500 - formData.observacao.length }} caracteres
							restantes</span>
					</div>

					<div class="form-group">
						<label for="local">Local</label>
						<input type="text" id="local" v-model="formData.local" placeholder="Local" />
					</div>

					<div class="form-group">
						<label for="cidade">Cidade</label>
						<input type="text" id="cidade" v-model="formData.cidade" required placeholder="Cidade" />
					</div>

					<div class="form-group">
						<label for="estado">Estado</label>
						<input type="text" id="estado" v-model="formData.estado" placeholder="Estado" />
					</div>
				</div>

				<div class="error" v-if="error">{{ error }}</div>
				<div class="success" v-if="success">{{ success }}</div>

				<div class="form-actions">
					<button @click="cadastrar()" class="btn btn-primary">Salvar</button>
					<button @click="router.push('/dashboard')" class="btn btn-secondary">
						Cancelar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

const router = useRouter()
const route = useRoute()

const formData = reactive({
	id: "",
	nome: "",
	idade: "",
	telefone: "",
	responsavel: "",
	observacao: "",
	cidade: "",
	local: "",
	estado: "",
	data_criacao: ""
})

const error = ref("");
const success = ref("");

onMounted(() => {
	pesquisaUsuario();
})


function validaCampos() {
	if (
		formData.nome == "" ||
		formData.idade == "" ||
		formData.telefone == "" ||
		formData.cidade == "" ||
		formData.estado == ""
	) {
		error.value = "Você precisa preencher os campos obrigatórios";
		return false;
	}
	if (formData.idade < 18 && !formData.responsavel.trim()) {
		error.value = "Para menores de 18 anos, o responsável é obrigatório";
		return false;
	}

	return true;
}

function cadastrar() {
	if (!validaCampos()) return;
	salvarOffline();
	success.value = "Alterações salvar com sucesso!";
	setTimeout(() => {
		router.push("/dashboard");
	}, 2000);
}
function salvarOffline() {
	const leadsOffline = JSON.parse(
		localStorage.getItem("leads_offline") || "[]"
	);
	error.value = "";
	const novoLead = {
		idade: parseInt(formData.idade),
		telefone: formData.telefone.replace(/\D/g, ""),
		email:
			formData.nome.toLowerCase().replace(/\s+/g, ".") +
			formData.telefone.replace(/\D/g, "") +
			"@sememail.com.br",
		...formData,
		enviado_bubble: false,
		created_at: formData.data_criacao,
	};

	const indice = leadsOffline.findIndex((u) => u.id === formData.id);

	if (indice !== -1) {
		leadsOffline[indice] = {
			...leadsOffline[indice],
			...novoLead,
		};
	}

	localStorage.setItem("leads_offline", JSON.stringify(leadsOffline));

	setTimeout(() => {
		success.value = "";
	}, 5000);
}

function formatPhone(event) {
	let value = event.target.value.replace(/\D/g, "");
	if (value.length <= 11) {
		value = value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
	}
	formData.telefone = value;
}
function pesquisaUsuario() {
	let leads = localStorage.getItem("leads_offline") || null;
	if (leads == null) router.push("/dashboard");
	leads = JSON.parse(leads);
	let lead = leads.find((u) => u.id === route.params.id);
	formData.id = lead.id;
	formData.nome = lead.nome;
	formData.idade = lead.idade;
	formData.telefone = lead.telefone;
	formData.responsavel = lead.responsavel;
	formData.observacao = lead.observacao;
	formData.cidade = lead.cidade;
	formData.local = lead.local;
	formData.estado = lead.estado;
	formData.data_criacao = lead.created_at
}
</script>

<style scoped>
.page-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 2rem;
}

.candidate-form {
	max-width: 800px;
}

.form-row {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 2rem;
	margin-bottom: 1rem;
}

.form-actions {
	display: flex;
	gap: 1rem;
	margin-top: 2rem;
}

@media (max-width: 768px) {
	.page-header {
		gap: 1rem;
	}

	.form-row {
		grid-template-columns: 1fr;
		gap: 0;
	}

	.form-actions {
		flex-direction: column;
	}
}
</style>
